import { render } from "./ProductEditForm.vue?vue&type=template&id=cbeea120&scoped=true&ts=true"
import script from "./ProductEditForm.vue?vue&type=script&lang=ts"
export * from "./ProductEditForm.vue?vue&type=script&lang=ts"

import "./ProductEditForm.vue?vue&type=style&index=0&id=cbeea120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbeea120"]])

export default __exports__